// =============================================================================
// IMPORTS
// =============================================================================
import React from "react";

// =============================================================================
// COMPOSANT HEADER - Composant "présentationnel" (ou "dumb component")
// =============================================================================
// Ce composant ne gère pas d'état, il reçoit simplement des données (props)
// et les affiche. C'est un composant "pur" : même props = même affichage.

// DESTRUCTURING DES PROPS :
// Au lieu d'écrire : function Header(props) { ... props.player1 ... }
// On utilise la déstructuration : { player1, player2, ... }
// Cela extrait directement les valeurs des props dans des variables

// Tableau pour mapper les valeurs de dés aux icônes Font Awesome
const diceIcons = {
    1: "fa-dice-one",
    2: "fa-dice-two",
    3: "fa-dice-three",
    4: "fa-dice-four",
    5: "fa-dice-five",
    6: "fa-dice-six"
};

function Header({ player1, player2, dice1, dice2, currentPlayer }) {
    // ===========================================================================
    // RENDU JSX
    // ===========================================================================
    // Ce composant retourne uniquement du JSX (pas de logique complexe)
    // C'est une bonne pratique de séparer la logique (App.js) de l'affichage

    return (
        <header>
            {/* Titre principal du jeu avec icône */}
            <h1>
                <i className="fas fa-dice"></i> Jeu de Dés
            </h1>

            {/* Conteneur des cartes de score des joueurs */}
            <div className="scores-container">
                {/* Carte Joueur 1 - Thème Bleu */}
                <div className={`player-card player1 ${currentPlayer === 1 ? 'active' : ''}`}>
                    <h3>
                        <i className="fas fa-user"></i> Joueur 1
                    </h3>
                    <div className="score">{player1}</div>
                    <div className="turn-indicator">
                        {currentPlayer === 1 ? "C'est votre tour !" : "En attente..."}
                    </div>
                </div>

                {/* Carte Joueur 2 - Thème Orange */}
                <div className={`player-card player2 ${currentPlayer === 2 ? 'active' : ''}`}>
                    <h3>
                        <i className="fas fa-user"></i> Joueur 2
                    </h3>
                    <div className="score">{player2}</div>
                    <div className="turn-indicator">
                        {currentPlayer === 2 ? "C'est votre tour !" : "En attente..."}
                    </div>
                </div>
            </div>

            {/* Affichage des dés avec icônes Font Awesome */}
            <div className="dice-container">
                <div className="dice">
                    <i className={`fas ${diceIcons[dice1]}`}></i>
                </div>
                <div className="dice">
                    <i className={`fas ${diceIcons[dice2]}`}></i>
                </div>
            </div>
        </header>
    );
}

// =============================================================================
// EXPORT
// =============================================================================
// On exporte le composant pour pouvoir l'utiliser dans App.js
// avec : import Header from './components/Header'

export default Header;
